import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";

import axios from "axios";
import { IoCloseSharp, BsImages, IoBookSharp } from "../../components/utils/icons";
import { useStateContext } from '../../context/ContextProvider';
import { TextQill } from './utils';
import { DLabel,  DSpinButton } from '../utils/Form';

import { toast } from 'react-toastify';
import { Loader } from '../utils';

import { BaseUrl } from '../../server';
function CreateBook() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const [errorMessage, setErrorMessage] = useState("");
  const [isSpinner, setIsSpinner] = useState(false);
  const [titleAr, setTitleAr] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textAr, setTextAr] = useState("");
  const [date ,setDate]=useState()
  const [image, setImage] = useState();
  const [book , setBook]=useState(null)
  const [bookShow , setBookShow]=useState()
  
  const [imageShow, setImageShow] = useState();

  const bookHandle = (e) => {
    const selectedFile = e.target.files[0];

    // تحقق مما إذا تم اختيار ملف
    if (!selectedFile) {
      toast.warning(<span className='text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm'>الرجاء اختيار ملف</span>);
      setErrorMessage(<span className=' font-kufi text-red-500 text-lg'>الرجاء اختيار ملف</span>);
      return;
    }


    if (selectedFile.type !== "application/pdf") {
      toast.warning(<span className='text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm'>الرجاء اختيار ملف PDF فقط</span>);
setErrorMessage(<span className='font-kufi text-red-500 text-sm'>الرجاء اختيار ملف PDF فقط</span>);
      setBook(null);
      return;
    }

    // إذا كان الملف صالحًا
    setErrorMessage("");
    setBook(selectedFile);
  };



  const inmageHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setImageShow(imageUrl);
    }
  };

  const changebook = (book) => {
    if (book) {
      const tempUrl = { url: URL.createObjectURL(book) }; // كائن مباشر
      setBookShow(tempUrl);
      setBook(book);
    }
  };
  const removebook = () => {
    setBook();
    setBookShow();
  };

  const changeImage = (img) => {
    if (img) {
      const tempUrl = { url: URL.createObjectURL(img) }; // كائن مباشر
      setImageShow(tempUrl);
      setImage(img);
    }
  };

  const removeImage = () => {
    setImage();
    setImageShow();
  };

  const CreateService = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
        const { data } = await axios.post(`${BaseUrl}/books/create`, newForm, config );
        if(data.success){
        // عرض رسالة نجاح
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Book created successfully!")}</span>);

        // إعادة تعيين الحالات
        setIsSpinner(false);
        setTitleAr("");
        setTitleEn("");
        setTextAr("");
        setDate("")
        setTextEn("");
setBook()
setBookShow()

        setImage("");
        setImageShow(""); // تأكد من أن هذه الدالة موجودة وتعمل بشكل صحيح
        }
    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
    if (image instanceof File === false) {
toast.warning(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Please Add Image")}</span>)
setIsSpinner(false);
  }
  
  else if (book instanceof File === false) {
    toast.warning(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Please Add book")}</span>)
    setIsSpinner(false);
      }
      else { const newForm = new FormData();
   
   
        newForm.append("file", book);
        newForm.append("date", date);
        newForm.append("image", image);
        newForm.append("titleAr", titleAr);
        newForm.append("titleEn", titleEn);
        newForm.append("textAr", textAr);
        newForm.append("textEn", textEn);
      
       CreateService(newForm)}
   

  };

  return (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Create Book")}
        </h3>
        <form onSubmit={handleSubmit}>
          <br />
          <div>
        
          <DLabel
              labelText="Title (Ar)"
              value={titleAr}
              onChange={(e)=> {setTitleAr(e.target.value)}}
              required={true}
              type="text"
              name="titleAr"
            />
             <DLabel
              labelText="Title (En)"
              value={titleEn}
              onChange={(e)=> {setTitleEn(e.target.value)}}
              required={true}
              type="text"
              name="titleAr"
            />
        
        <DLabel
              labelText="Date"
              value={date}
              onChange={(e)=> {setDate(e.target.value)}}
              required={true}
              type="date"
              name="date"
            />

  <label  className="pb-2 text-tcolor-5  text-md font-kufi"> 
              {t("Upload Image")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              name=""
              id="upload"
              className="hidden"
              onChange={inmageHandle}
            />
  
            {imageShow ? (
              <div className="h-[180px] relative">
                <label htmlFor="0">
                  <img
                    className="w-full h-full rounded-lg border"
                    src={imageShow.url} // الوصول إلى url مباشرةً
                    alt=""
                    style={{
                      borderColor: currentColor,
                    }}
                  />
                </label>
                <input
                  onChange={(e) => changeImage(e.target.files[0])}
                  type="file"
                  id="0"
                  className="hidden"
                />
                <span
                  onClick={removeImage}
                  className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                  style={{ backgroundColor: currentColor }}
                >
                  <IoCloseSharp />
                </span>
              </div>
            ) : (
              <label
                className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
                htmlFor="image"
                style={{
                  borderColor: currentColor,
                }}
              >
                <span>
                  <BsImages size={40} color={currentColor} />
                </span>
                <span
                className="pb-2 text-color-1  text-md font-kufi"
              
                >
                  {t("Select Image")}
                </span>
              </label>
            )}
  
            <input
              onChange={inmageHandle}
              className="hidden"
              type="file"
              id="image"
            />
            <br />
            
<label className="pb-2 text-tcolor-5  text-md font-kufi">
                {t("Upload book")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name=""
                id="book-upload"
                className="hidden"
                onChange={bookHandle}
              />
                  {errorMessage && <p className='text-red-500'>{errorMessage}</p>}
{book ? (
  <div className="h-[180px] relative">
    <label htmlFor="book-upload">
    <h2 className="body-1 text-color-1 ">
تم إختيار الملف :
    {book instanceof File && book.name }
     </h2>
    </label>
    <input
      onChange={(e) => changebook(e.target.files[0])} // تصحيح إلى files[0]
      type="file"
      id="book-upload" // معرف فريد
      className="hidden"
    />
    <span
      onClick={removebook}
      className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
      style={{ backgroundColor: currentColor }}
    >
      <IoCloseSharp />
    </span>
  </div>
) : (
  <label
    className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
    htmlFor="book-upload" // مطابقة مع المعرف الجديد
    style={{ borderColor: currentColor }}
  >
    <span><IoBookSharp size={40} color={currentColor} /></span>
    <span className="text font-kufi text-md" style={{ color: currentColor }}>
      {t("Select book")}
    </span>
  </label>
)}


              <input
                onChange={bookHandle}
                className="hidden"
                type="file"
                id="book-upload"
              />
              <br />
          </div>
          <DSpinButton isLoading={isSpinner}>{t("Create")}</DSpinButton>
        </form>
      </div>
  
  );
}

export default CreateBook;